import { render, staticRenderFns } from "./HeaderConfig.vue?vue&type=template&id=4dd6717e&scoped=true"
import script from "./HeaderConfig.vue?vue&type=script&lang=js"
export * from "./HeaderConfig.vue?vue&type=script&lang=js"
import style0 from "./HeaderConfig.vue?vue&type=style&index=0&id=4dd6717e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6717e",
  null
  
)

export default component.exports